import React from 'react'

import { Page } from '../clean/adapters/presenters/react/components/molecules/Page'

const HomePage = ({ pageContent }) => {
  return <Page.WithIntro pageContent={pageContent}></Page.WithIntro>
}

export default HomePage
